module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f1609970007001"
    }
  }), _c('h2', {
    staticClass: "chapter-title"
  }, [_vm._v("Sew Many Bags …")]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("It’s a fact of life that every girl loves bags, and it is never possible to have too many! I’m still putting this theory to the test… This book will give you a taste of how quick and easy (not to mention fun!) it is to make your own bags, choosing fabrics and embellishments that you love!")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("All the bags featured are simple to make and many of them are suitable for even total beginners who’ve never picked up a needle and thread in their life. By choosing the fabrics and colours carefully you can have a selection of fantastic bags to cover all occasions, from funky work and shopping bags to cute vanity cases and toiletry bags. And each bag has matching accessories, so you can make purses, notebooks and photo frames too!")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("You don’t need expensive or specialist equipment to make your own bags – just a basic sewing kit and sewing machine. The key to making fabulous bags is to choose the fabrics carefully. Look out for materials that inspire you – they could be bought from haberdashery stores, or from the internet, or you could even use cut-up clothing! Add buttons, beads and sequins, ribbons and braids, or anything else you like!")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bag handles and accessories are becoming ever easier to buy – the internet has a vast selection of suppliers, where you can find all you need. Handles come in a variety of styles and materials, from sophisticated metals and stylish wood to funky coloured plastic, so you can get the look you really want.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("This book should inspire you to make bags that suit your own style and personality – and hopefully have fun while doing it!")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("Happy bag making!")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c343e2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch005.vue
// module id = 69
// module chunks = 0